import { ProductTemplateChecklistCard } from 'types/productServiceV2';

interface ProductTemplateCardTextObject {
  title: string;
  text: string;
  redirectTo: (templateId: string, type: ProductTemplatePageType) => string;
}

export type ProductTemplatePageType = 'templates' | 'browsing';

interface RFQChecklistURLData {
  templateId: string;
  type?: ProductTemplatePageType;
}

type CardDataObjectType = {
  [K in ProductTemplateChecklistCard]: ProductTemplateCardTextObject;
};

export const PRODUCT_TEMPLATE_CARD_DATA: CardDataObjectType = Object.freeze({
  POLICY_ATTRIBUTES: {
    title: 'Policy Attributes',
    text: 'High level policy attributes',
    redirectTo: (templateId: string, type = 'templates'): string => {
      return `/policy-attributes/${templateId}?type=${type}`;
    },
  },
  PLAN_ATTRIBUTES: {
    title: 'Plan Attributes',
    text: 'Benefit level configurations',
    redirectTo: (templateId: string, type = 'templates'): string => {
      return `/plan-attributes/${templateId}?type=${type}`;
    },
  },
  GENERATE_PDF: {
    title: 'Generate PDF',
    text: 'Custom product pdf generator',
    redirectTo: (templateId: string, type = 'templates'): string => {
      return `/generate-pdf/${templateId}?type=${type}`;
    },
  },
  BENEFIT_SUMMARY: {
    title: 'Benefit Summary',
    text: 'Upload a document to describe and support the product',
    redirectTo: (templateId: string, type = 'templates'): string => {
      return `/benefit-summary/${templateId}?type=${type}`;
    },
  },
  SAVE_PRODUCT_TEMPLATE: {
    title: 'Save Product',
    text: 'Final step to save your work so you can add a new product variant to a proposal',
    redirectTo: (templateId: string, type = 'templates'): string => {
      return `/save-product-template/${templateId}?type=${type}`;
    },
  },
});

/**
 * Generates a URL for the RFQ product template checklist based on the provided params.
 * @returns The constructed URL for the RFQ checklist.
 */
export const getRFQProductTemplateChecklistURL = ({ templateId, type = 'templates' }: RFQChecklistURLData): string => {
  return `/product-template-checklist/${templateId}?type=${type}`;
};
